class ComponentForm {
  constructor() {
    this._init();
  }

  _init() {
    document.querySelectorAll<HTMLInputElement>('form input, form textarea').forEach((input) => {
      input.addEventListener('focus', () => {
        input.closest('.contact-form__item')?.classList.add('focused');
      });

      input.addEventListener('blur', () => {
        if (input.value.trim() === '') {
          input.classList.remove('filled');
          input.closest('.contact-form__item')?.classList.remove('focused');
        } else {
          input.closest('.contact-form__item')?.classList.remove('filled');
        }
      });
    });
  }
}

export const componentForm = new ComponentForm();
